import { getLocale } from '@components/Utility/Shared/SharedService';
import config from '@config';
import axios from 'axios';
import forEach from 'lodash/forEach';
import {
  filterBuildUrls,
  getCurrentRegion,
  getLatestBuild,
} from 'services/commonService';
import { tryGetPreviewData } from 'utils';
import { IsoBackendHttpService } from 'utils/IsoBackendHttpService';

let isCache = false;
const API_PREFIX = '/content/fetchiso';

export const getLandingPaths = async (level, url, notMatchText, section) => {
  const data = config.BUILD_URLS?.OTHERS?.enabled
    ? config.BUILD_URLS.OTHERS
    : await getLatestBuild(
        process.env.NEXT_PUBLIC_BUILD_ID ||
          process.env.env_var_others_build_id ||
          process.env.env_var_build_id
      );
  let urlArr = filterBuildUrls(
    section || 'project_samskriti_microsite',
    level,
    url,
    notMatchText,
    data
  );
  // console.log('ps service data', url, level, data, urlArr);
  return urlArr ? urlArr : [];
};

export const fetchDetails = async (
  region,
  lang,
  slug = ``,
  previewData,
  siteSection
) => {
  if (previewData?.preview) {
    return await tryGetPreviewData(previewData, getLocale(region, lang, 'iso'));
  }
  const pageData = await new IsoBackendHttpService().get(
    `${API_PREFIX}/content`,
    !isCache,
    {
      params: {
        format: 'json',
        sitesection: siteSection ? `${siteSection}` : `projectsamskriti`,
        slug: `${slug}`,
        region,
        lang,
      },
    }
  );

  return pageData;
};

export const fetchUpcomingWorkShop = async (
  id,
  region,
  isFree,
  isOnline,
  count,
  startrec
) => {
  let url = `${
    config.SCHEDULE_API_PATH
  }?option=com_program&v=2&format=json&task=filter&samskriti=1&region=${
    region || 'in'
  }`;
  if (id) {
    url = `${url}&category=${id}`;
  }
  if (isFree) {
    url = `${url}&is_free=1`;
  }
  if (isOnline) {
    url = `${url}&is_online=1`;
  }
  if (count || startrec) {
    url = `${url}&count=${count}&startrec=${startrec}`;
  }
  const resp = await axios({
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    url: url,
  });
  return await resp?.data;
};

export const fetchProductionDetails = async id => {
  // console.log(id, "fetchchant")
  const resp = await axios({
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    url: `${config.SCHEDULE_API_PATH}?option=com_program&v=2&format=json&task=details&program_id=${id}&samskriti=1`,
  });
  return await resp?.data;
};

export const fetchMenuItem = async () => {
  // console.log(id, "fetchchant")
  const resp = await axios({
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    url: config.PS_MENU_API,
  });
  return await resp?.data;
};

export const fetchChantsDetails = async id => {
  const resp = await axios({
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    url: `${config.SCHEDULE_API_PATH}?option=com_program&v=2&format=json&task=filter&category=${id}&samskriti=1`,
  });
  return await resp?.data;
};

export const fetchProgramPrices = async ids => {
  const resp = await axios({
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      event_ids: ids,
    },
    url: config.PS_OVERSEAS_PRICING_API,
  });
  return await resp?.data;
};

export const fetchNirvanaDetails = async id => {
  const resp = await axios({
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    url: `${config.SCHEDULE_API_PATH}?option=com_program&v=2&format=json&task=filter&category=${id}&samskriti=1`,
  });

  return await resp?.data;
};

export const fetchUpcomingListData = async (
  catId,
  isFree,
  isOnline,
  count,
  startrec
) => {
  const reg = await getCurrentRegion();
  // console.log('fetchUpcomingListData', count, startrec)
  if (reg?.country) {
    const upcomingProgramsList = await fetchUpcomingWorkShop(
      catId,
      reg?.country === 'IN' ? 'in' : 'ov',
      isFree,
      isOnline,
      count,
      startrec
    );
    // console.log(upcomingProgramsList, "upcoming result");
    if (upcomingProgramsList.results) {
      const extracted = upcomingProgramsList.results.flatMap(item =>
        Object.values(item).map(obj => ({
          ...obj,
          filterDate: obj.samskriti?.startdate
            ? new Date(obj.samskriti.startdate).toISOString().split('T')[0]
            : null,
        }))
      );

      let newPrices = [];
      // console.log('upcomingProgramsList', upcomingProgramsList);
      if (reg?.country !== 'IN') {
        const workIds = [];
        extracted.map(el => {
          workIds.push(el.samskriti?.event_id);
        });
        newPrices = await fetchProgramPrices(workIds);
        // console.log('extracted', extracted, newPrices, workIds);
        newPrices = newPrices.result;
        if (newPrices.length) {
          forEach(newPrices, function (cardPrice) {
            forEach(extracted, function (item) {
              if (item.samskriti.event_id?.toString() === cardPrice.id?.toString()) {
                item.amount = cardPrice.tickets[0]?.price;
                item.currency = cardPrice.tickets[0]?.currency;
                // console.log('setExtractedObjects11', cardPrice, item);
              }
            });
          });
        }
      }
      let { resultcount } = upcomingProgramsList;
      return count || startrec ? { extracted, resultcount } : extracted;
    }
  }
};
